import { CandyIcon } from './CandyIcon';

/**
 * author: Michael Irigoyen
 * id AC3D0F93-E7EB-42DE-BBFE-FEBAE7966B35
 * name candy
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/candy.svg
 * tags
 * - Food / Drink 
 */
export const ChocolateIcon = CandyIcon;
export default ChocolateIcon